import eyeOpenIcon from '@/assets/eye-icon.svg'
import eyeClosedIcon from '@/assets/eye-off-icon.svg'

/** Open eye when plain text is visible; crossed eye when masked (dots). */
export function passwordVisibilityIconSrc(visible: boolean): string {
  return visible ? eyeOpenIcon : eyeClosedIcon
}
